import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Assets

import healthcare from "../../assets/img/healthcare.jpg";
import bd1 from "../../assets/img/bd-1.jpg";
import bd2 from "../../assets/img/bd-2.jpg";
import bd3 from "../../assets/img/bd-3.png";
import bd4 from "../../assets/img/bd-4.jpeg";
import bd5 from "../../assets/img/bd-5.jpeg";
import bd6 from "../../assets/img/bd-6.jpg";
import bd7 from "../../assets/img/bd-7.jpeg";
import bd8 from "../../assets/img/bd-8.jpg";
import bd9 from "../../assets/img/bd-9.jpeg";
import bd10 from "../../assets/img/bd-10.jpeg";
import bd11 from "../../assets/img/bd-11.jpg";
import bd12 from "../../assets/img/bd-12.jpeg";
import bd13 from "../../assets/img/bd-13.jpg";
import bd14 from "../../assets/img/bd-14.jpeg";
import bd15 from "../../assets/img/bd-15.jpeg";
import bd16 from "../../assets/img/bd-16.jpeg";
import bd17 from "../../assets/img/bd-17.jpeg";
import bd18 from "../../assets/img/bd-18.jpg";
import bd19 from "../../assets/img/bd-19.jpg";

export default function ClientSlider() {
  const settings = {
    infinite: false,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 2,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <Slider {...settings}>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={healthcare} alt="healthcare" />
          <p className="label">HEALTHCARE</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd1} alt="RESTAURANTS" />
          <p className="label">RESTAURANTS</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd2} alt="GROCERY AND ORGANIC" />
          <p className="label">GROCERY AND ORGANIC</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd3} alt="FASHION" />
          <p className="label">FASHION</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd4} alt="ELECTRONICS AND LARGE APPLIANCES" />
          <p className="label">ELECTRONICS AND LARGE APPLIANCES</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd5} alt="HOME AND OFFICE FURNITURE" />
          <p className="label">HOME AND OFFICE FURNITURE</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd6} alt="PHARMA AND MEDICOS" />
          <p className="label">PHARMA AND MEDICOS</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd7} alt="HOME DÉCOR AND FURNISHING" />
          <p className="label">HOME DÉCOR AND FURNISHING</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd8} alt="PET SHOPPE" />
          <p className="label">PET SHOPPE</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd9} alt="GARDEN AND OUTDOOR" />
          <p className="label">GARDEN AND OUTDOOR</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd10} alt="FOOD AND AGRO" />
          <p className="label">FOOD AND AGRO</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd11} alt="AUTOMOBILE" />
          <p className="label">AUTOMOBILE</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd12} alt="HEALTH AND MEDICAL EQUIPMENTS" />
          <p className="label">HEALTH AND MEDICAL EQUIPMENTS</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd13} alt="HOME OFFICE & AUTOMOBILE SERVICES" />
          <p className="label">HOME OFFICE & AUTOMOBILE SERVICES</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd14} alt="AUTOMOBILE SPARE PARTS" />
          <p className="label">AUTOMOBILE SPARE PARTS</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd15} alt="KITCHEN AND DINING" />
          <p className="label">KITCHEN AND DINING</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd16} alt="ELECTRICAL AND LIGHTING" />
          <p className="label">ELECTRICAL AND LIGHTING</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd17} alt="MOBILE AND ENTERTAINMENT GADGETS" />
          <p className="label">MOBILE AND ENTERTAINMENT GADGETS</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd18} alt="SANITARY PAINTS AND FURNISHINGS" />
          <p className="label">SANITARY PAINTS AND FURNISHINGS</p>
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={bd19} alt="DE-EVENTO" />
          <p className="label">DE-EVENTO</p>
        </LogoWrapper>
      </Slider>
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 300px;
  height: 200px;
  cursor: pointer;
  padding: 5%;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;
const ImgStyle = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 5px;
`;
